import React, { useEffect, useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import Title from '../Components/Simple/Title';
import { enableBatchDashboard, enableEnabledPricers, enableFQHCPricer } from '../Utils/features';
import { Button, ErrorMessage } from "../Components/Simple";
import PricerSelection from '../Components/Combined/PricerSelection';
import { enablePricerTypeLookup, enableDataAccessApi } from '../Utils/features';
import { ModulesContext } from '../App';
import { IPPS, SNF, HH, LTCH, REHAB, PSYCH, OPPS, PFS, ESRD, FQHC } from '../Constants/modelTypes';
import { Spinner } from 'react-bootstrap';
import PDFDownloadButton from '../Components/Simple/PDFDownloadButton';

const USER_GUIDE_FILENAME = process.env.REACT_APP_USER_GUIDE_FILE;
const RELEASE_NOTE_FILENAME = process.env.REACT_APP_RELEASE_NOTES_FILE;
const RELEASE_NOTE_VERSION = process.env.REACT_APP_RELEASE_NOTES_VERSION;
const FREQUENTLY_ASKED_QUESTION_DOC = process.env.REACT_APP_FREQUENTLY_ASKED_QUESTIONS_FILE;

function Home() {
    const { modules, loading } = useContext(ModulesContext);
    const lowerCaseModules = enableEnabledPricers ? modules.map(module => module.toLowerCase()) : [];
    const [showAutoPricerModal, setAutoPricerModal] = useState(false);
    const [errors, setErrors] = useState([]);

    useEffect(() => {
        for (const k of Object.keys(sessionStorage).filter(k => k.indexOf('field.') === 0)) {
            sessionStorage.removeItem(k);
        }
    }, []);

    const closeAutoPricerModal = () => {
        setAutoPricerModal(false);
    }

    const openAutoPricerModal = () => {
        setAutoPricerModal(true);
    }

    const addError = (error) => {
        setErrors(prev => [...prev, error]);
    };

    const clearErrors = () => {
        setErrors([]);
    };

    return (
        <>
            <Title />
            <div className="row justify-content-center">
                <div className="col-lg-10">
                    <div className="row justify-content-center row-cols-md-5 g-3">
                        {enableEnabledPricers && loading ? (
                            <div className="d-flex justify-content-center align-items-center" style={{ height: '100px' }}>
                                <Spinner animation="border" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </Spinner>
                            </div>
                        ) : enableEnabledPricers && lowerCaseModules.length === 0 ? (
                            <div className="d-flex justify-content-center align-items-center" style={{ height: '100px' }}>
                                <h5>No pricers enabled for you. Please contact us if you think this is a mistake!</h5>
                            </div>
                        ) : (
                            <>
                                {(!enableEnabledPricers || lowerCaseModules.includes(IPPS.toLowerCase())) && (
                                    <div className="col-md d-grid">
                                        <Link to="/pricer/ip/acute" className="btn btn-secondary">
                                            IP Acute Pricer
                                        </Link>
                                    </div>
                                )}
                                {(!enableEnabledPricers || lowerCaseModules.includes(SNF.toLowerCase())) && (
                                    <div className="col-md d-grid">
                                        <Link to="/pricer/snf" className="btn btn-secondary">
                                            SNF Pricer
                                        </Link>
                                    </div>
                                )}
                                {(!enableEnabledPricers || lowerCaseModules.includes(HH.toLowerCase())) && (
                                    <div className="col-md d-grid">
                                        <Link to="/pricer/hh" className="btn btn-secondary">
                                            Home Health Pricer
                                        </Link>
                                    </div>
                                )}
                                {(!enableEnabledPricers || lowerCaseModules.includes(LTCH.toLowerCase())) && (
                                    <div className="col-md d-grid">
                                        <Link to="/pricer/ltch" className="btn btn-secondary">
                                            LTCH Pricer
                                        </Link>
                                    </div>
                                )}
                                {(!enableEnabledPricers || lowerCaseModules.includes(REHAB.toLowerCase())) && (
                                    <div className="col-md d-grid">
                                        <Link to="/pricer/ip/rehab" className="btn btn-secondary">
                                            IP Rehab Pricer
                                        </Link>
                                    </div>
                                )}
                                {(!enableEnabledPricers || lowerCaseModules.includes(PSYCH.toLowerCase())) && (
                                    <div className="col-md d-grid">
                                        <Link to="/pricer/ip/psych" className="btn btn-secondary">
                                            IP Psych Pricer
                                        </Link>
                                    </div>
                                )}
                                {(!enableEnabledPricers || lowerCaseModules.includes(OPPS.toLowerCase())) && (
                                    <div className="col-md d-grid">
                                        <Link to="/pricer/opps" className="btn btn-secondary">
                                            OPPS/ASC Pricer
                                        </Link>
                                    </div>
                                )}
                                {(!enableEnabledPricers || lowerCaseModules.includes(PFS.toLowerCase())) && (
                                    <div className="col-md d-grid">
                                        <Link to="/pricer/pfs" className="btn btn-secondary">
                                            Professional Pricer
                                        </Link>
                                    </div>
                                )}
                                {(!enableEnabledPricers || lowerCaseModules.includes(ESRD.toLowerCase())) && (
                                    <div className="col-md d-grid">
                                        <Link to="/pricer/esrd" className="btn btn-secondary">
                                            Dialysis Pricer
                                        </Link>
                                    </div>
                                )}
                                {(enableFQHCPricer && (!enableEnabledPricers || lowerCaseModules.includes(FQHC.toLowerCase()))) && (
                                    <div className="col-md d-grid">
                                        <Link to="/pricer/fqhc" className="btn btn-secondary">
                                            FQHC Pricer
                                        </Link>
                                    </div>
                                )}
                            </>
                        )}
                    </div>

                    {/* This simply helps with visibility of modal */}
                    {showAutoPricerModal && <div className="modal-backdrop fade show" style={{ marginTop: '60px' }}> </div>}
                    <div className={`modal ${showAutoPricerModal ? 'show' : ''} fade show`} id="autoModal" tabIndex="-1" aria-labelledby="autoModalLabel" aria-hidden={!showAutoPricerModal} style={showAutoPricerModal ? { display: 'block', top: '80px' } : { display: 'none', top: '80px' }}>
                        <div className="modal-dialog modal-lg">
                            <div className="modal-content" style={{ marginBottom: '20%' }}>
                                <div className="modal-header">
                                    <h5 className="modal-title" id="autoModalLabel">Pricer Selector</h5>
                                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={closeAutoPricerModal}></button>
                                </div>
                                <div className="modal-body">
                                    {showAutoPricerModal && <PricerSelection />}
                                </div>
                            </div>
                        </div>
                    </div>

                    {enablePricerTypeLookup && <div className="mt-1 row justify-content-center row-cols-md-5 g-5">
                        <button type="button" className="btn btn-secondary" onClick={openAutoPricerModal}>Pricer Selector</button>
                    </div>}

                    {enableBatchDashboard && <div className={`mt-1 row justify-content-center row-cols-md-5 ${enablePricerTypeLookup ? 'g-3' : 'g-5'}`}>
                        <Link to="/upload/batch" className="btn btn-secondary">
                            Batch Submission
                        </Link>
                    </div>}
                </div>
            </div>

            <div className="container">
                <div className="row justify-content-center mt-4 mb-4">
                    <div className="col-auto">
                        <PDFDownloadButton
                            fileName={RELEASE_NOTE_FILENAME}
                            buttonText={`Release Notes ${RELEASE_NOTE_VERSION}`}
                            onError={addError}
                            onClick={clearErrors}
                        />
                    </div>
                </div>
                <div className="row justify-content-center mb-4">
                    <div className="col-auto">
                        <PDFDownloadButton
                            fileName={USER_GUIDE_FILENAME}
                            buttonText="Download User Guide"
                            onError={addError}
                            onClick={clearErrors}
                        />
                    </div>
                </div>
                <div className="row justify-content-center mb-4">
                    <div className="col-auto">
                        <PDFDownloadButton
                            fileName={FREQUENTLY_ASKED_QUESTION_DOC}
                            buttonText="Frequently Asked Questions"
                            onError={addError}
                            onClick={clearErrors}
                        />
                    </div>
                </div>
            </div>

            {errors.length > 0 && (
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-auto">
                            <ErrorMessage errors={errors.map(error => ({ message: error }))} />
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default Home;
